import { OfflineRequestError } from 'utils/errorCodes'
import { ApiRequestQueue } from './api/queue'
import { ApiRequestStatus, ApiRequestType } from './api/queue/types'
import { serviceCenterPlannedGatewayReposition } from './api/serviceCenterPlannedGatewayReposition'

export const repositionPlannedGateway = async (param: {
  pseudogatewayId: number
  location: string
  propertyId: number
}) => {
  try {
    // Request may or may not have been completed by the time the promise resolves
    const { status } = await ApiRequestQueue.createRequest(ApiRequestType.REPOSITION_PSEUDO_GATEWAY, param)

    if (status === ApiRequestStatus.COMPLETED) return
  } catch (error) {
    // If the request failed because the app is offline, don't throw an error
    if (!(error instanceof OfflineRequestError)) {
      throw error
    }
  }

  serviceCenterPlannedGatewayReposition.callback(param)
}
